import $ from "jquery";

$(document).ready(function () {
	$(".read-more__button").on("click", function () {
		if (!$(this).hasClass("read-more--open")) {
			$(this).text("Les mindre");
			$(this).addClass("read-more--open");
			$(this)
				.parent()
				.find(".step-item__content")
				.addClass("step-item__content--open");
		} else {
			$(this).text("Les mer");
			$(this).removeClass("read-more--open");
			$(this)
				.parent()
				.find(".step-item__content")
				.removeClass("step-item__content--open");
		}
	});
});
